export default "__VITE_ASSET__37ed55a3__"